var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loader"},[_c('q-spinner-pie',{attrs:{"color":"primary","size":"40px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }